import styled from "styled-components";
import Responsable from "../../../Responsable";
import { media } from "../../../../constants/styles";

const SMtown = () => {
  const srcRoot = '/image/webp/project/smtown/content';

  return <><Responsable
    pc={
      <ContentContainer>
        <img src={`${srcRoot}/smtown-pc-1.png`} width={'100%'} height={'100%'} style={{ objectFit: 'cover' }} />
        <video autoPlay muted loop src={`${srcRoot}/smtown-pc-2.mov`} width={'100%'} height={'100%'} style={{ objectFit: 'cover' }} />
        <img src={`${srcRoot}/smtown-pc-3.png`} width={'100%'} height={'100%'} style={{ objectFit: 'cover' }} />

        <Section4Container>
          <div>
            <img src={`${srcRoot}/smtown-pc-4.png`} width={'100%'} height={'100%'} style={{ objectFit: 'cover' }} />
          </div>
          <PhoneContainer>
            <PhoneMockup>
              <img src="/image/webp/project/smtown/content/phone-mockup.png" width={'100%'} height={"auto"} />
              <PhoneVedioContainer>
                <PhoneVedio autoPlay muted loop src="/image/webp/project/smtown/content/smtown-pc-video.mp4" />
                <AiViewerImage />
              </PhoneVedioContainer>
            </PhoneMockup>
          </PhoneContainer>
        </Section4Container>
      </ContentContainer>
    }
    tablet={<>
      <ContentContainer>
        <img src={`${srcRoot}/smtown-tablet-1.png`} width={'100%'} height={'100%'} style={{ objectFit: 'cover' }} />
        <video autoPlay muted loop src={`${srcRoot}/smtown-tablet-2.mov`} width={'100%'} height={'100%'} style={{ objectFit: 'cover' }} />
        <img src={`${srcRoot}/smtown-tablet-3.png`} width={'100%'} height={'100%'} style={{ objectFit: 'cover' }} />
        <Section4Container>
          <div>
            <img src={`${srcRoot}/smtown-pc-4.png`} width={'100%'} height={'100%'} style={{ objectFit: 'cover' }} />
          </div>
          <PhoneContainer>
            <PhoneMockup>
              <img src="/image/webp/project/smtown/content/phone-mockup.png" width={'100%'} height={"auto"} />
              <PhoneVedioContainer>
                <PhoneVedio autoPlay muted loop src="/image/webp/project/smtown/content/smtown-pc-video.mp4" />
                <AiViewerImage />
              </PhoneVedioContainer>
            </PhoneMockup>
          </PhoneContainer>
        </Section4Container>
      </ContentContainer></>
    }
    mobile={<>
      <ContentContainer>
        <img src={`${srcRoot}/smtown-mobile-1.png`} width={'100%'} height={'100%'} style={{ objectFit: 'cover' }} />
        <video autoPlay muted loop src={`${srcRoot}/smtown-tablet-2.mov`} width={'100%'} height={'100%'} style={{ objectFit: 'cover' }} />
        <img src={`${srcRoot}/smtown-mobile-3.png`} width={'100%'} height={'100%'} style={{ objectFit: 'cover' }} />
        <Section4Container>
          <div>
            <img src={`${srcRoot}/smtown-pc-4.png`} width={'100%'} height={'100%'} style={{ objectFit: 'cover' }} />
          </div>
          <PhoneContainer>
            <PhoneMockup>
              <img src="/image/webp/project/smtown/content/phone-mockup.png" width={'100%'} height={"auto"} />
              <PhoneVedioContainer>
                <PhoneVedio autoPlay muted loop src="/image/webp/project/smtown/content/smtown-pc-video.mp4" />
                <AiViewerImage />
              </PhoneVedioContainer>
            </PhoneMockup>
          </PhoneContainer>
        </Section4Container>
      </ContentContainer>
    </>}
  /></>;
};

export { SMtown };

const ContentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0;
  
  img {
    width: 100%;
    margin-bottom: -1px;
    object-fit: cover;
  }
  video {
    margin-bottom: -2px;
  }
`;

const Section4Container = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);

  ${media.TABLET} {
    grid-template-columns: repeat(1, 1fr);
  }
  `

const PhoneContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: #F7F9FA;
  
  
  ${media.TABLET} {
    aspect-ratio: 1 / 1;
  }
`;

const PhoneMockup = styled.div`
  position: relative;
  width: 40%;
`;

const PhoneVedioContainer = styled.div`
  position: absolute;
  width: 93%;
  height: 96.5%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50.2%);
`;

const PhoneVedio = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 2vw;
  user-select: none;
  
  ${media.TABLET} {
    border-radius: 5vw;
  }
`;

const AiViewerImage = styled.div`
position: absolute;
top: 0;
left: 0;
right: 0;
bottom: 0;
  background: url('/image/webp/project/smtown/content/smtown-pc-ai-viewer.png') no-repeat center center / cover;
`;
